import { WifiOff } from 'lucide-react';

export default function OfflineBanner() {
  return (
    <div className="bg-amber-500 text-white text-center py-2 px-4 text-sm font-medium flex items-center justify-center gap-2 z-50">
      <WifiOff size={16} />
      <span>You&apos;re offline. Some features may be limited.</span>
    </div>
  );
}
